import React, { useEffect, useState } from 'react';
import { ShoppingCartIcon } from 'lucide-react';
import { trackAddToCart, trackLead, trackClick, trackInitiateCheckout } from '../utils/metaPixel';
interface StickyCTAProps {
  isOrderBumpChecked?: boolean;
}
export function StickyCTA({
  isOrderBumpChecked = false
}: StickyCTAProps) {
  const [isVisible, setIsVisible] = useState(false);
  const totalPrice = isOrderBumpChecked ? 25490 : 17990;
  const priceText = `$${totalPrice.toLocaleString('es-AR')}`;
  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className={`fixed bottom-0 left-0 right-0 z-40 transition-transform duration-500 ease-out ${isVisible ? 'translate-y-0' : 'translate-y-full'}`} data-id="element-208">
      <div className="bg-forest/95 backdrop-blur-md border-t border-white/10 shadow-[0_-4px_20px_rgba(0,0,0,0.15)] px-4 py-3" data-id="element-209">
        <div className="max-w-3xl mx-auto flex items-center justify-between gap-3" data-id="element-210">
          {/* Price info */}
          <div className="hidden sm:block text-white shrink-0" data-id="element-211">
            <p className="text-xs text-white/70 leading-tight" data-id="element-212">
              <span className="line-through" data-id="element-213">$89.000</span> → Precio lanzamiento
            </p>
            <p className="text-xl font-bold leading-tight transition-all duration-300" data-id="element-214">
              {priceText}{' '}
              <span className="text-xs font-normal text-white/60" data-id="element-215">ARS</span>
            </p>
            {isOrderBumpChecked && <p className="text-[10px] text-amber-300 leading-tight mt-0.5" data-id="element-216">
                ✨ Incluye Kit del Sueño Profundo
              </p>}
          </div>

          {/* CTA Button */}
          <a href={isOrderBumpChecked ? 'https://ebookpromax.com/cart/add?id=46629774295198&quantity=1' : 'https://ebookpromax.com/cart/add?id=46629742641310&quantity=1'} target="_blank" rel="noopener noreferrer" onClick={() => {
          trackAddToCart(isOrderBumpChecked ? 25490 : 17990, 'ARS', isOrderBumpChecked ? 'Botiquín Ancestral + Kit del Sueño' : 'Botiquín Ancestral');
          trackLead('Sticky CTA - Comprar Ahora');
          trackClick('sticky_cta');
          trackInitiateCheckout();
        }} className="flex-1 sm:flex-none inline-flex items-center justify-center gap-2 bg-white text-forest font-bold text-base sm:text-lg px-6 py-3 rounded-xl hover:bg-cream transition-colors shadow-lg active:scale-[0.98]" data-id="element-217">
            <ShoppingCartIcon className="w-5 h-5" data-id="element-218" />
            <span className="sm:hidden" data-id="element-219">COMPRAR AHORA — {priceText}</span>
            <span className="hidden sm:inline" data-id="element-220">
              🛒 QUIERO MI BOTIQUÍN AHORA
            </span>
          </a>
        </div>
      </div>
    </div>;
}